// https://ui.shadcn.com/view/styles/new-york/sidebar-07
// https://tailwindcss.com/plus/ui-blocks/application-ui/lists/feeds

import { AppSidebar } from '@/components/Sidebar/app-sidebar';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Separator } from '@/components/ui/separator';
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@/components/ui/Sidebar/sidebar';

/* function UnusedApp() {
  const [tickets, setTickets] = useState<any>(null);

  const fetchTickets = () => {
    fetch(
      "/api/tickets?select=id,number,title,description,status,due&order=created.desc&limit=10",
    )
      .then((res) => res.json())
      .then((data) => {
        setTickets(data);
      });
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  return (
    <div>
      <h1>Tickets</h1>
      <Button onClick={fetchTickets}>Fetch tickets</Button>
      {tickets && <DataTable columns={columns} data={tickets} />}
      <h1>Create Ticket</h1>
      <TicketForm
        onSubmit={async (data) => {
          toast.info(<pre>{JSON.stringify(data, null, 2)}</pre>);
          const cte: Draft<CreateTicketEvent> = {
            id: crypto.randomUUID(),
            type: "CREATE_TICKET",
            payload: {
              title: data.title,
              description: data.description,
              status: data.status,
              due: data.due,
              project_id: 1,
              werk_id: 1,
              assignee_user_id: 1,
              executor_user_id: 1,
              add_labels: [],
            },
            ticket_id: data.id,
            user_id: 1,
            created: new Date(),
          };
          toast.info(<pre>{JSON.stringify(cte, null, 2)}</pre>);

          const res = await fetch("/api/tickets", {
            method: "POST",
            body: JSON.stringify(cte),
            headers: {
              "Content-Type": "application/json",
            },
          });
          if (res.ok) {
            fetchTickets();
            toast.success("Ticket created", {
              description: <pre>{JSON.stringify(data, null, 2)}</pre>,
            });
          } else {
            toast.error("Failed to create ticket", {
              description: (
                <pre>{JSON.stringify(await res.json(), null, 2)}</pre>
              ),
            });
          }
        }}
      />
    </div>
  );
}

// export default UnusedApp;
*/

export default function Page() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header
          className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear
            group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12"
        >
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem className="hidden md:block">
                  <BreadcrumbLink href="#">
                    Building Your Application
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator className="hidden md:block" />
                <BreadcrumbItem>
                  <BreadcrumbPage>Data Fetching</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>
        </header>
        <div className="flex flex-1 flex-col gap-4 p-4 pt-0">
          <div className="grid auto-rows-min gap-4 md:grid-cols-3">
            <div className="bg-muted/50 aspect-video rounded-xl" />
            <div className="bg-muted/50 aspect-video rounded-xl" />
            <div className="bg-muted/50 aspect-video rounded-xl"></div>
          </div>
          <div className="bg-muted/50 min-h-[100vh] flex-1 rounded-xl md:min-h-min" />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
